import { CommonLabel } from "@brg/ui";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { FC } from "react";
import { MagicBoxRow } from "shared/components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import { ProjectEditPageGridRow } from "shared/components/ProjectEditPageGrid";

interface CheckboxFieldProps {
    label: string;
    infoText?: string;
    checked: boolean;
    onClick: () => void;
}

const CheckboxField: FC<CheckboxFieldProps> = ({ label, infoText, checked, onClick }) => {
    return (
        <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
            <CommonLabel
                label={label}
                infoText={infoText}
                fixedHeight
                onWhiteBG
            />
            <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
                <MagicBoxRow
                    className="checkbox"
                    checked={checked}
                    label={''}
                    onClick={onClick}
                    isTeamEdit
                />
            </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
    )
}

export default CheckboxField;import { CommonLabel } from "@brg/ui";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { FC } from "react";
import { MagicBoxRow } from "shared/components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar";
import { ProjectEditPageGridRow } from "shared/components/ProjectEditPageGrid";

interface CheckboxFieldProps {
    label: string;
    infoText?: string;
    checked: boolean;
    onClick: () => void;
}

const CheckboxField: FC<CheckboxFieldProps> = ({ label, infoText, checked, onClick }) => {
    return (
        <ProjectEditPageGridRow style={{ marginTop: 24 }} isCheckbox isTeamEdit>
            <CommonLabel
                label={label}
                infoText={infoText}
                fixedHeight
                onWhiteBG
            />
            <ProjectEditPageGridInput isTeamEdit isCheckbox align="center" alignMobile="center">
                <MagicBoxRow
                    className="checkbox"
                    checked={checked}
                    label={''}
                    onClick={onClick}
                    isTeamEdit
                />
            </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
    )
}

export default CheckboxField;